"use client";

import { Star } from "lucide-react";

import { useI18n } from "@/components/i18n-provider";
import { useCvsReviewedCount } from "@/hooks/use-cvs-reviewed-count";
import {
  formatCvsReviewed,
  formatFreeReviewTime,
  formatRating,
} from "@/lib/proof-stats";

/**
 * Thin trust strip. Labels come from the dictionary; every number comes from
 * the proof-stats module, so only verifiable, rounded-down figures are shown.
 */
export function OfferStatsBand() {
  const { locale, dictionary } = useI18n();
  const cvsReviewed = useCvsReviewedCount();
  const labels = dictionary.home.stats;
  const hero = dictionary.dashboard.offerPage.hero;

  const stats = [
    { label: labels.cvsReviewed, value: formatCvsReviewed(locale, cvsReviewed) },
    { label: labels.freeReview, value: formatFreeReviewTime(locale) },
  ];

  return (
    <div className="rounded-2xl border border-border-primary bg-card">
      <dl className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 px-6 py-5 sm:justify-between sm:gap-x-6">
        {stats.map((stat) => (
          <div key={stat.label} className="flex items-baseline gap-2">
            <dt className="sr-only">{stat.label}</dt>
            <dd className="flex items-baseline gap-2">
              <span className="text-2xl font-bold tracking-tight text-text-heading">
                {stat.value}
              </span>
              <span className="text-sm text-text-muted">{stat.label}</span>
            </dd>
          </div>
        ))}
        <div className="flex items-center gap-2">
          <Star className="size-5 fill-amber-400 text-amber-400" aria-hidden="true" />
          <span className="text-2xl font-bold tracking-tight text-text-heading">
            {formatRating(locale)}
          </span>
          <span className="text-sm text-text-muted">{hero.ratingNote}</span>
        </div>
      </dl>
    </div>
  );
}
